export const compareScore = function (a, b) {
  let a_score = a.score * 1
  let b_score = b.score * 1
  if (a_score > b_score) {
    return -1
  }
  if (a_score < b_score) {
    return 1
  }
  return 0
}

export default {
  compareScore
}
